export function formatDuration(minutes) {
  if (!Number.isFinite(minutes) || minutes <= 0) return 'Duration unavailable';
  const total = Math.round(minutes);
  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const remainingMinutes = total % 60;
  return [
    days && `${days} day${days === 1 ? '' : 's'}`,
    hours && `${hours} hr`,
    remainingMinutes && `${remainingMinutes} min`,
  ].filter(Boolean).join(' ') || 'Less than 1 min';
}
